import { styled } from "@mui/material";
import { FC } from "react";

import ChevronUpIcon from '../../../icons/ChevronUpIcon';
import ChevronDownIcon from '../../../icons/ChevronDownIcon';

interface SortTableColumnIconProps {
    direction: 'asc' | 'desc' | false;
}

const SortIconBothWrapper = styled('span')({
    marginLeft: 4,
    height: '1.5em',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.3,
});

const SortIconWrapper = styled('span')({
    marginLeft: 4,
    height: '1.5em',
    display: 'flex',
    alignItems: 'center',
});

export const SortTableColumnIcon: FC<SortTableColumnIconProps> = ({ direction }) => {
    if (!direction) {
        return (
            <SortIconBothWrapper>
                <ChevronUpIcon className="w-3 h-2" />
                <ChevronDownIcon className="w-3 h-2" />
            </SortIconBothWrapper>
        );
    }
    
    return (
        <SortIconWrapper>
            {direction === 'asc' 
                ? <ChevronUpIcon className="w-3 h-2" />
                : <ChevronDownIcon className="w-3 h-2" />
            }
        </SortIconWrapper>
    );
};